var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeLoaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.27758 6.33325H0.5V3.55566",
    stroke: "white",
    strokeWidth: 0.933318,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3035 10.4995C20.3035 4.9766 15.8272 0.500244 10.3042 0.500244C6.27008 0.500244 2.80366 2.89341 1.22266 6.33317",
    stroke: "white",
    strokeWidth: 0.933318,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1881 10.4991L13.6391 12.3701C13.7902 12.5645 13.8724 12.8045 13.8724 13.0512V14.11C13.8724 14.4166 13.6236 14.6655 13.3169 14.6655H7.67954C7.37289 14.6655 7.12402 14.4166 7.12402 14.11V13.0312C7.12402 12.7979 7.19735 12.569 7.33512 12.3801L8.69613 10.4991L7.33512 8.61927C7.19846 8.42928 7.12402 8.20152 7.12402 7.9682V6.88828C7.12402 6.58164 7.37289 6.33276 7.67954 6.33276H13.3169C13.6236 6.33276 13.8724 6.58164 13.8724 6.88828V7.94709C13.8724 8.19374 13.7902 8.43373 13.6391 8.62816L12.1881 10.4991Z",
    stroke: "white",
    strokeWidth: 0.933318,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7227 14.6663H20.5002V17.4438",
    stroke: "white",
    strokeWidth: 0.933318,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.695312 10.4995C0.695312 16.0225 5.17166 20.4988 10.6946 20.4988C14.7277 20.4988 18.1952 18.1056 19.7762 14.6659",
    stroke: "white",
    strokeWidth: 0.933318,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLoaderIcon);
export default __webpack_public_path__ + "static/media/time-loader-icon.de6115469057530f0f994bd72f2866f2.svg";
export { ForwardRef as ReactComponent };